<template>
  <div class="partner_list_container">
    <div class="partner_header_container" v-show="!newPartnerDialogVisible">
      <div class="new_item_add_button" v-show="allowGridAddNewPartner" @click="addNewItemInstant">
        <i class="fas fa-plus"></i>
      </div>
    </div>
    <DxDataGrid
      :element-attr="gridAttributes"
      ref="partnerGrid"
      class="partner_grid"
      :data-source="dataSource"
      :no-data-text="addNewItemInfoText"
      :show-column-headers="false"
      :hover-state-enabled="true"
      :remote-operations="isRemoteOperation"
      :repaint-changes-only="true"
      :selected-row-keys="localSelectedPartners"
      @selection-changed="onGridSelectionChanged($event)"
      @content-ready="onGridContentReady($event)"
      @row-click="onRowClick"
      height="100%"
      :columns="dataColumns"
      v-show="!newPartnerDialogVisible"
    >
      <DxSelection :mode="multiselect ? 'multiple' : 'single'" showCheckBoxesMode="always" />
      <DxFilterRow :visible="true" />
      <DxPaging :enabled="true" />
      <DxScrolling mode="infinite" />
      <DxGrouping :autoExpandAll="true" />
      <DxGroupPanel :visible="false" />
    </DxDataGrid>

    <div class="reception_tabs" v-if="newPartnerDialogVisible">
      <div class="filter_container" :use-native="true">
        <div class="reception_input_holder">
          <div class="input_label">Denumire</div>
          <div class="input_value">
            <DxTextBox placeholder="Introduceți denumire" v-model="newPartner.name" class="global_dx_textbox" />
          </div>
        </div>

        <div class="reception_input_holder">
          <div class="input_label">CUI/RO/CNP</div>
          <div class="input_value">
            <DxTextBox placeholder="Introduceți CUI" v-model="newPartner.id_number" class="global_dx_textbox" />
          </div>
        </div>
      </div>
      <div class="reception_bottom_sticky">
        <div style="display: flex; flex-direction: row; width: 100%">
          <div class="sticky_action_button" style="margin-right: 6px" @click="saveNewPartner">Salvează</div>
          <div class="sticky_action_button_second" style="margin-left: 6px" @click="newPartnerDialogVisible = false">Anulează</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { DxDataGrid, DxColumn, DxSelection, DxFilterRow, DxScrolling, DxGrouping, DxGroupPanel, DxPaging } from "devextreme-vue/data-grid";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxPopup from "devextreme-vue/popup";
import DxTextBox from "devextreme-vue/text-box";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";

export default {
  name: "PartnerSelector",
  props: {
    addNewText: {
      type: String,
      default: () => "Partner nu există",
    },
    allowAddNew: {
      type: Boolean,
      default: () => false,
    },
    localDataset: {
      type: Array,
      default: () => [],
    },
    dataColumns: {
      type: Array,
      default: () => [
        { dataField: "name", caption: "Denumire" },
        { dataField: "legal_form_name", caption: "Formă juridică" },
      ],
    },
    hasError: false,
    multiselect: {
      type: Boolean,
      default: () => false,
    },
    isRemoteOperation: {
      type: Boolean,
      default: () => true,
    },
    selectedPartners: {
      type: Array,
      default: () => [],
    },
    toastMessageRef: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      allowGridAddNewPartner: false,
      gridAttributes: {
        class: "grid_general_mobile_style",
      },
      localSelectedPartners: [],
      newPartnerDialogVisible: false,
      newPartner: {
        name: "",
        id_number: "",
        legal_form: "SRL",
        partner_type: 1,
      },
    };
  },
  components: {
    DxScrollView,
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxFilterRow,
    DxScrolling,
    DxGrouping,
    DxGroupPanel,
    DxPaging,
    DxPopup,
    DxTextBox,
  },
  computed: {
    addNewItemInfoText() {
      if (this.allowAddNew) {
        return this.addNewText + ", apasă butonul de adăugare!";
      } else {
        return this.addNewText;
      }
    },
    dataSource() {
      if (this.isRemoteOperation) {
        return this.customStore;
      }

      return this.localDataset;
    },
    customStore() {
      return new DataSource({
        store: new CustomStore({
          //key: "uuid",
          load: this.getPartners,
          byKey: async function (key) {
            return new Promise((resolve) => resolve("success"));
          },
        }),
      });
    },
  },
  methods: {
    ...mapActions({
      getPartners: "smPartners/getSmPartners",
      createSmPartner: "smPartners/createSmPartner",
    }),
    onGridSelectionChanged(e) {
      this.localSelectedPartners = Array.isArray(e.selectedRowKeys) ? [...e.selectedRowKeys] : [];
      this.$emit("update:selectedPartners", this.localSelectedPartners);
    },
    onRowClick(e) {
      // Prevent default behavior if the row is already selected and multiselect is false
      if (!this.multiselect) {
        return;
      }

      const rowKey = e.key; // Get the unique key of the clicked row
      const selectedIndex = this.localSelectedPartners.indexOf(rowKey);

      if (selectedIndex === -1) {
        // If the row is not selected, add it to the selection
        this.localSelectedPartners.push(rowKey);
      } else {
        // If the row is already selected, remove it from the selection
        this.localSelectedPartners.splice(selectedIndex, 1);
      }

      // Update the grid's selected rows
      this.$refs.partnerGrid.instance.selectRows(this.localSelectedPartners, false);
      this.$emit("update:selectedPartners", this.localSelectedPartners);
    },
    onGridContentReady(e) {
      if (e.component.getVisibleRows().length <= 0 && this.allowAddNew) {
        this.allowGridAddNewPartner = true;
      } else {
        this.allowGridAddNewPartner = false;
      }
    },
    initNewItem(data) {
      if (!this.multiselect) {
        this.localSelectedPartners = [];
      }
      this.localSelectedPartners.push(data.uuid);
      this.$refs.partnerGrid.instance.selectRows(this.localSelectedPartners, false);
      const selectedPartners = this.multiselect
        ? [...this.selectedPartners.filter((partner) => partner?.uuid !== data.uuid), data]
        : [data];
      this.$emit("update:selectedPartners", selectedPartners);

      /*if (!this.multiselect) {
        this.$emit("continue");
      }*/
    },
    addNewItemInstant() {
      const gridFilter = this.$refs.partnerGrid.instance.getCombinedFilter();
      const partnerName = gridFilter && gridFilter.filterValue ? gridFilter.filterValue : "";
      this.newPartner.name = partnerName || "";
      this.newPartner.id_number = "";
      this.newPartnerDialogVisible = true;
    },
    async saveNewPartner() {
      if (!this.newPartner.name?.trim() || !this.newPartner.id_number) {
        this.toastMessageRef.showError("Numele și CUI/RO/CNP sunt obligatorii!");
        return;
      }
      try {
        const payload = {
          name: this.newPartner.name,
          id_number: this.newPartner.id_number,
          legal_form: this.newPartner.legal_form,
          partner_type: this.newPartner.partner_type,
        };
        const response = await this.createSmPartner(payload);
        this.newPartnerDialogVisible = false;
        // Refresh grid data
        if (this.$refs.partnerGrid && this.$refs.partnerGrid.instance) {
          await this.$refs.partnerGrid.instance.refresh();
        }
        // Select the newly created partner if response contains it
        const created = response?.data?.data || response?.data || null;
        const createdUuid = created?.uuid;
        if (createdUuid) {
          this.initNewItem({
            ...this.newPartner,
            ...created,
            uuid: createdUuid,
            name: created.name || this.newPartner.name,
            id_number: created.id_number || this.newPartner.id_number,
          });
        }
      } catch (e) {
        if (e.response.status === 400 || e.response.status === 500) {
          if (e.response.data.errors && e.response.data.errors.error) {
            this.toastMessageRef.showError("A apărut o eroare la salvarea partenerului! " + e.response.data.errors.error);
          } else {
            console.log("partner save error: ", e?.response);
            this.toastMessageRef.showError("A apărut o eroare la salvarea partenerului!");
          }
        } else {
          console.log("partner save error: ", e?.response);
          this.toastMessageRef.showError("A apărut o eroare la salvarea partenerului!");
        }
      }
    },
  },
  watch: {
    selectedPartners: {
      handler(newVal) {
        this.localSelectedPartners = Array.isArray(newVal) ? [...newVal] : [];
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/dxMobileGridGeneral.scss";

.partner_list_container {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  padding-right: 5px;
}

.partner_header_container {
  display: flex;
  justify-content: end;
  align-items: end;
  padding-right: 24px;
  padding-bottom: 10px;
}
</style>
